import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Red running text shown at the TOP of every ortu page, driven by Bendahara-created
 * pemberitahuan (koleksi `pemberitahuan_bendahara`).
 */
export default function OrtuRunningText() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/pemberitahuan-bendahara");
        if (alive) setItems(data || []);
      } catch { /* ignore */ }
    };
    load();
    // Refresh every 60s so pesan baru cepat muncul & terhapus otomatis
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, [user?.linked_id]);
  if (!user || user.role !== "orangtua" || items.length === 0) return null;
  const message = items.map((it) => it.isi).join(" · ");
  return (
    <div className="bg-red-600 text-white overflow-hidden w-full" data-testid="ortu-running-text">
      <div className="whitespace-nowrap py-2 animate-marquee text-sm font-medium">
        <span className="mx-8">{message}</span>
        <span className="mx-8">{message}</span>
      </div>
    </div>
  );
}
